const getAPIDomain = () => {
    if (process.env.NODE_ENV === 'development') {
        return 'https://content-dev.theinformationlab.co.uk';
    } else {
        return 'https://www.theinformationlab.co.uk';
    }
}

module.exports = { getAPIDomain };  